/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-11-30 14:09:49
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-04-12 10:34:30
 */

const TokenKey = 'token'

export function getToken() {
  return localStorage.getItem(sessionStorage.getItem('appid')+TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(sessionStorage.getItem('appid')+TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(sessionStorage.getItem('appid')+TokenKey)
}


export function getOpenid() {
  return localStorage.getItem(sessionStorage.getItem('appid')+'openid')
}

export function setOpenid(openid) {
  return localStorage.setItem(sessionStorage.getItem('appid')+'openid', openid)
}

export function removeOpenid() {
  return localStorage.removeItem(sessionStorage.getItem('appid')+'openid')
}



// WEBPACK FOOTER //
// ./src/utils/auth.js